import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { RootService } from '../../../../shared/services/root.service';
import { Subject } from 'rxjs';
import { environment } from '@env/environment';
import { MenuStateService } from '../../../header/components/menu-categorias-b2c/services/menu-state.service';
import { LocalStorageService } from 'src/app/core/modules/local-storage/local-storage.service';
import { CartService } from '@core/services-v2/cart.service';

@Component({
  selector: 'app-mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss'],
})
export class MobileHeaderComponent implements OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  logoSrc = environment.logoSrc;

  constructor(
    public menuCategorias: MenuStateService,
    private router: Router,
    public root: RootService,
    public cart: CartService,
    public localS: LocalStorageService
  ) {}

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  Hidebar(): boolean {
    /*let url = null;
    if (this.router.url.split('?')[0] != undefined) {
      url = '' + this.router.url.split('?')[0];
    }*/
    if (this.router.url.includes('/carro-compra/')) {
      return false;
    } else {
      return true;
    }
  }
}
